import { useState, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { SetImg } from './store.js';
import { Static } from './util.js';

// Custom Hook
export const ImageLoader = () => {
  const store = useSelector((state) => state);
  const dispatch = useDispatch();
  const imgState = useSelector(state => state.img || {});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const keysRef = useRef([]);

  // 이미지 키 추가
  const addImgKey = useCallback((key) => {
    if (!keysRef.current.includes(key)) {
      keysRef.current.push(key);
    }
  }, []);

  // 여러 이미지 키 추가
  const addImgKeys = useCallback((keys) => {
    keys.forEach(key => {
      if (!keysRef.current.includes(key)) {
        keysRef.current.push(key);
      }
    });
  }, []);

  // 현재 저장된 키 목록 반환
  const getImgKeys = useCallback(() => {
    return [...keysRef.current];
  }, []);

  // 키 목록 초기화
  const clearImgKeys = useCallback(() => {
    keysRef.current = [];
  }, []);

  // 이미지 로드 함수
  const loadImgs = useCallback(async (callback = null) => {
    // 이미 로딩 중이면 중복 실행 방지
    if (loading) return;

    // 로드할 이미지가 없으면 종료
    if (keysRef.current.length === 0) {
      if (callback) callback([]);
      return;
    }

    setLoading(true);
    setError(null);

    // 이미 로드된 이미지는 제외
    const filteredKeys = keysRef.current.filter(key => !imgState.hasOwnProperty(key));

    if (filteredKeys.length === 0) {
      if (callback) callback([]);
      clearImgKeys();
      setLoading(false);
      return;
    }

    // 키를 청크로 나누기 (한 번에 4개씩 요청)
    const chunks = [];
    for (let i = 0; i < filteredKeys.length; i += 4) {
      chunks.push(filteredKeys.slice(i, i + 4));
    }

    let allUrls = [];

    try {
      await Promise.all(chunks.map(async (chunk) => {
        if (chunk.length === 0) return;

        console.log('gets3urls == ' + chunk);

        const response = await axios.post(Static.SvrAddr + 'gets3urls', {
          keys: chunk
        });

        const urls = response.data.urls;

        for (let i = 0; i < urls.length; i++) {
          dispatch(SetImg({ key: chunk[i], url: urls[i] }));
          console.log('gets3urls ====== ' + chunk[i] + ' ' + urls[i]);
        }

        allUrls = allUrls.concat(urls);
      }));

      if (callback) callback(allUrls);
    } catch (err) {
      console.error('이미지 로드 중 오류 발생:', err);
      setError(err);
      if (callback) callback(null);
    } finally {
      clearImgKeys();
      setLoading(false);
    }
  }, [dispatch, imgState, loading, clearImgKeys]);

  return {
    addImgKey,
    addImgKeys,
    getImgKeys,
    clearImgKeys,
    loadImgs,
    loading,
    error
  };
};

export const ImgSlot = ({ imgKey, className, style, onClick }) => {
  const store = useSelector((state) => state);

  return store.img[imgKey] == null ? (
    <p className="placeholder-glow">
      <span className={`placeholder bg-secondary ${className}`} style={style}></span>
    </p>
  ) : (
    <img
      className={className}
      src={store.img[imgKey]}
      style={style}
      alt=""
      onClick={onClick}
    />
  );
};
